import SearchStore from '@d-store/modules/search';
import CardsStore from '@d-shared/store/cards';

export default {
  Cards: CardsStore,
  Search: SearchStore,
};
